<template>
    <div class="h-screen w-full bg-blue flex items-center justify-center fixed pin-t pin-l">
        <div class="max-w-sm w-full mx-2">
            <div class="flex justify-center pb-8 mb-8">
                <logo style="max-width:120px"></logo>
            </div>
            <form @submit.prevent="submit" v-if="!sent">
                <form-group label="Email Address" name="email" :invert="true" :required="true">
                    <input type="text" name="email" id="email" class="input input--invert text-white" v-model="email">
                </form-group>

                <form-group label="Issue" name="issue" :invert="true" :required="true">
                    <textarea rows="10" name="issue" id="issue" class="input input--invert text-white resize-none" v-model="issue"></textarea>
                </form-group>

                <div class="flex py-8 items-center justify-center flex-col md:flex-row">
                    <div>
                        <brand-button type="submit" color="invert">Submit Issue</brand-button>
                    </div>
                </div>
            </form>
            <div class="text-grey-light" v-if="sent">
                <p>Thanks for reaching out!</p>

                <p>Our support will check your message in the nearest time.</p>
            </div>
            <router-link tag="div" class="text-center" :to="{ name: 'login' }">
                <a href="#" class="text-white text-sm hover:text-white hover:underline">Back to login form.</a>
            </router-link>
        </div>
    </div>
</template>

<script>
    import auth from '../auth'
    export default {
        data() {
            return {
                email: null,
                issue: '',
                sent: false,
            }
        },

        methods: {
            submit() {
                auth.requestLoginIssue(this.email, this.issue, (success, errors) => {
                    if (errors) {
                        this.$store.commit('setErrors', {errors: errors});
                    }
                    if (success) {
                        this.sent = true;
                        this.$store.commit('clearErrors');
                    }
                });
            }
        },
    }
</script>
